(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/dialog/assets/javascripts/areas/toaster-area.js') >= 0) return;  svs.modules.push('/components/components/dialog/assets/javascripts/areas/toaster-area.js'); "use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }


(function (svs, gsap) {
  'use strict';

  svs = svs || {};
  svs.components = svs.components || {};
  svs.components.dialog = svs.components.dialog || {};

  var DialogToasterArea = function (_svs$components$dialo) {
    _inherits(DialogToasterArea, _svs$components$dialo);

    var _super = _createSuper(DialogToasterArea);

    function DialogToasterArea(options) {
      var _this;

      _classCallCheck(this, DialogToasterArea);

      _this = _super.call(this);
      _this.log = new svs.core.log.Logger('DialogToasterArea');
      _this.name = svs.components.dialog.area.TOASTER;
      _this.items = [];
      _this.el = options.el;
      _this.options = options;

      _this.render();

      _this.init();

      return _this;
    }

    _createClass(DialogToasterArea, [{
      key: "init",
      value: function init() {
        var _this2 = this;

        window.addEventListener('resize', function () {
          var currentItem = _this2.items[0];

          if (currentItem) {
            _this2.setPositions();
          }
        });
      }
    }, {
      key: "render",
      value: function render() {
        this.el = document.createElement('div');
        this.el.className += 'js-dialog-items dialog-items dialog-toaster-items js-dialog-toaster-items';
        this.options.attachTo.appendChild(this.el);
      }
    }, {
      key: "remove",
      value: function remove() {
        this.options && this.options.attachTo && this.options.attachTo.removeChild(this.el);
        this.el = null;
        this.emit('close');
      }
    }, {
      key: "add",
      value: function add(dialog) {
        var popups = this.options.areas[svs.components.dialog.area.POPUP];

        if (!this.el) {
          this.render();
        }

        if (!popups || !popups.count() || popups && popups.count() === 1 && popups.items[0]._isClosing) {
          this.log.debug('Added to toasters');
          this.append(dialog);
          dialog.reveal();
          this.updatePositions();
        } else {
          this.log.debug('Added to popups');
          dialog.allowDimmerClick = false;
          popups.add(dialog);
        }
      }
    }, {
      key: "close",
      value: function close(timing) {
        var _this3 = this;

        this.log.debug('No more dialogs here, close container', timing !== undefined ? timing : 0.2);
        var tweenVars = {
          height: 0,
          onComplete: function onComplete() {
            setTimeout(function () {
              _this3.remove();
            }, 100);
          }
        };

        if (timing === 0) {
          this.log.debug('Set height 0');
          gsap.set(this.el, tweenVars);
        } else {
          this.log.debug('Animate height 0');
          gsap.to(this.el, 0.2, tweenVars);
        }
      }
    }, {
      key: "append",
      value: function append(dialog) {
        var _this4 = this;

        this.log.debug('Append dialog to be opened');
        dialog._queue = this;
        dialog.el.className += ' dialog-toaster-item';
        dialog.on('closed', this, function () {
          _this4.log.debug('A dialog was closed, now handle it.');

          _this4.unload(dialog);
        });
        this.items.push(dialog);
        this.el.appendChild(dialog.el);
      }
    }, {
      key: "setPositions",
      value: function setPositions() {
        this.log.debug('Set positions on toaster items');
        var totalHeight = 0;
        this.items.forEach(function (item) {
          gsap.set(item.el, {
            top: totalHeight
          });
          totalHeight += item.el.offsetHeight;
        });
        gsap.set(this.el, {
          height: totalHeight
        });
      }
    }, {
      key: "updatePositions",
      value: function updatePositions() {
        this.log.debug('Update toaster items heights');
        var totalHeight = 0;
        this.items.forEach(function (item) {
          gsap.to(item.el, {
            duration: 0.2,
            top: totalHeight
          });
          totalHeight += item.el.offsetHeight;
        });
        gsap.to(this.el, {
          duration: 0.2,
          height: totalHeight
        });
      }
    }, {
      key: "unload",
      value: function unload(dialog) {
        var _this5 = this;

        this.items.forEach(function (item, i) {
          if (item._id === dialog._id) {
            _this5.items.splice(i, 1);

            gsap.to(item.el, {
              duration: 0.2,
              height: 0,
              onComplete: function onComplete() {
                _this5.el && _this5.el.removeChild(item.el);
              }
            });
            item._rendered = false;
          }
        });

        if (!this.items.length) {
          this.close();
        } else {
          this.updatePositions();
        }
      }
    }, {
      key: "convertToPopups",
      value: function convertToPopups() {
        var _this6 = this;

        this.log.debug("Convert ".concat(this.items.length, " toasters -> popups"));
        var convertedItems = [];
        this.items.forEach(function (item) {
          if (item.options.convertToPopup) {
            _this6.el.removeChild(item.el);

            item.off('closed', _this6);
            item.options.autoClose = false;
            item.el.removeAttribute('style');
            item.options.area = svs.components.dialog.area.POPUP;
            item.el.classList.remove('dialog-toaster-item');
            convertedItems.push(item);
          } else {
            _this6.log.debug("Toaster with title ".concat(item.options.title || '[not set]', " not converted to popup"));
          }
        });
        this.items = [];
        this.close(0);
        return !convertedItems.length ? false : convertedItems;
      }
    }, {
      key: "status",
      value: function status() {
        this.log.debug("".concat(this.name, " queue, ").concat(this.items.length, " still remain"));
      }
    }, {
      key: "count",
      value: function count() {
        var c = 0;
        this.items.forEach(function (item) {
          if (!item.options.skipPopupQueue) {
            c++;
          }
        });
        return c;
      }
    }]);

    return DialogToasterArea;
  }(svs.components.dialog.PubSub); 


  svs.components.dialog.DialogToasterArea = DialogToasterArea;
  svs.components.dialog.area = svs.components.dialog.area || {};
  svs.components.dialog.area.TOASTER = 'toaster';
  svs.components.dialog.areas = svs.components.dialog.areas || {};
  svs.components.dialog.areas[svs.components.dialog.area.TOASTER] = svs.components.dialog.DialogToasterArea;
})(svs, gsap);
 })(window);